import { render, staticRenderFns } from "./Reload.vue?vue&type=template&id=38e1571c&"
import script from "./Reload.vue?vue&type=script&lang=js&"
export * from "./Reload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports